import constants from '@/libs/constant/constants'
import {cloneDeep, isEmpty, filter, find} from 'lodash'
import {message,loader} from '@/libs/helper'
import { updateAuthor, updatePublisher, updatePublication } from '@/libs/api/api'
import locationFormMixin from '@/mixins/locationFormMixin';
import countryCode from '@/libs/constant/countrycode'

export default{
    name: 'ManageAuthorDescription',
    mixins: [locationFormMixin],
    props:{
        stepBack: {
            type: Function,
            default: ()=>{}
        },
        stepForward: {
            type: Function,
            default: ()=>{}
        },
        cancel: {
            type: Function,
            default: ()=>{}
        },
        showButtons: {
            type: Boolean,
            default: ()=> true
        },
        displayLocation: {
            type: Boolean,
            default: ()=> true
        },
        displayDescription: {
            type: Boolean,
            default: ()=> true
        },
        displayPublicationEditor: {
            type: Boolean,
            default: ()=> true
        },
        updateSource: {
            type: Function,
            default: () => {}
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: ()=> false
        },
        isEdit: {
            type: Boolean,
            default: ()=> false
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        adminEditButtons: {
            type: Boolean,
            default: false
        },
        isAdd: {
            type: Boolean,
            default: false
        }
    },
    beforeMount() {
        if (this.claimTo && this.claimTo.address && this.claimTo.address.country_code) {
            this.address.country_name = this.getCountryName()
        } else {
            this.address.country_name = (this.claimTo && this.claimTo.address && this.claimTo.address.country_name) || 'Netherlands'
        }
    },
    mounted () {
        this.findState()
    },
    watch: {
        claimTo (newValue) {
            this.des = {
                biography: newValue.biography || '',
                short_description: newValue.short_description || '',
                managing_editor: newValue.managing_editor || ''
            }
            this.address = {
                line1:  newValue.address && newValue.address.line1 || '',
                line2:  newValue.address && newValue.address.line2 || '',
                postal_code: newValue.address && newValue.address.postal_code || '',
                city: newValue.address && newValue.address.city || '',
                country_code: newValue.address && newValue.address.country_code || 'NL',
                country_name: newValue.address && newValue.address.country_name || ''
            }
            this.contact_detail = {
                phone: newValue.contact_detail && newValue.contact_detail.phone || '',
                fax: newValue.contact_detail && newValue.contact_detail.fax || '',
                email: newValue.contact_detail && newValue.contact_detail.email || ''
            }
            this.findState()
        }
    },
    data(){
        return {
            des: {
                biography: this.claimTo.biography || '',
                short_description: this.claimTo.short_description || '',
                managing_editor: this.claimTo.managing_editor || ''
            },
            address: {
                line1:  this.claimTo && this.claimTo.address && this.claimTo.address.line1 || '',
                line2:  this.claimTo && this.claimTo.address && this.claimTo.address.line2 || '',
                postal_code: this.claimTo && this.claimTo.address && this.claimTo.address.postal_code || '',
                city: this.claimTo && this.claimTo.address && this.claimTo.address.city || '',
                country_code: this.claimTo && this.claimTo.address && this.claimTo.address.country_code || 'NL',
                country_name: this.claimTo && this.claimTo.address && this.claimTo.address.country_name ||''
            },
            contact_detail: {
                phone: this.claimTo && this.claimTo.contact_detail && this.claimTo.contact_detail.phone || '',
                fax: this.claimTo && this.claimTo.contact_detail && this.claimTo.contact_detail.fax || '',
                email: this.claimTo && this.claimTo.contact_detail && this.claimTo.contact_detail.email || ''
            },
            validatePostalCode: this.validatePostalCodeFunction
        }
    },
    methods: {
        submitAuthorForm (forms) {
            let isAllFormsValid = true
            let claimTo = this.claimTo
            forms.map((formName)=>{
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        isAllFormsValid = false
                    }
                })
            })

            if(isAllFormsValid) {
                claimTo.biography = this.des.biography
                claimTo.short_description = this.des.short_description
                claimTo.address = this.address
                this.stepForward()
            }
        },
        submitPublisherForm (forms, isTrue) {
            let isAllFormsValid = true
            forms.map((formName)=>{
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        isAllFormsValid = false
                    }
                })
            })

            if(isAllFormsValid) {
                let claimTo = this.claimTo
                claimTo.biography = this.des.biography
                claimTo.short_description = this.des.short_description
                claimTo.address = this.address
                claimTo.contact_detail = this.contact_detail
                if (isTrue === undefined) this.stepForward()
                else if (isTrue) this.stepBack()
            }
        },
        submitPublicationForm (forms) {
            let isAllFormsValid = true
            forms.map((formName)=>{
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        isAllFormsValid = false
                    }
                })
            })


            if(isAllFormsValid) {
                let claimTo = this.claimTo
                claimTo.biography = this.des.biography
                claimTo.short_description = this.des.short_description
                claimTo.managing_editor = this.des.managing_editor
                claimTo.address = this.address
                this.stepForward()
            }
        },
        submitDescriptionForm(module, formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                loader(this, true)

                let body = {
                    biography: this.des.biography,
                    short_description: this.des.short_description
                }

                if(module === constants.AUTHOR.key){
                    updateAuthor(body, this.claimTo._id)
                        .then((response)=>{

                            let claimTo = cloneDeep(this.claimTo)
                            claimTo.biography = this.des.biography
                            claimTo.short_description = this.des.short_description
                            this.updateSource('DESCRIPTION', claimTo)
                            this.$store.dispatch('updateRegisteredAuthor', claimTo)

                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, (response.message))
                        })
                        .catch((error)=>{
                            loader(this, false)
                            message(this, constants.messageType.ERROR, (error.message))
                        })
                }else if(module === constants.PUBLISHER.key){
                    updatePublisher(body, this.claimTo._id)
                        .then((response)=>{
                            let claimTo = cloneDeep(this.claimTo)
                            claimTo.biography = this.des.biography
                            claimTo.short_description = this.des.short_description
                            this.updateSource('DESCRIPTION', claimTo)
                            this.$store.dispatch('updateRegisteredPublisher', claimTo)

                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, (response.message))
                        })
                        .catch((error)=>{
                            loader(this, false)
                            message(this, constants.messageType.ERROR, (error.message))
                        })

                }else if(module === constants.PUBLICATION.key){
                    updatePublication(body, this.claimTo._id)
                        .then((response)=>{
                            let claimTo = cloneDeep(this.claimTo)
                            claimTo.biography = this.des.biography
                            claimTo.short_description = this.des.short_description
                            claimTo.managing_editor = this.des.managing_editor
                            this.updateSource('DESCRIPTION', claimTo)
                            this.$store.dispatch('updateRegisteredPublication', claimTo)

                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, (response.message))
                        })
                        .catch((error)=>{
                            loader(this, false)
                            message(this, constants.messageType.ERROR, (error.message))
                        })

                }
            })
        },
        submitPublicationEditorForm(module, formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                loader(this, true)

                let body = {
                    managing_editor: this.des.managing_editor
                }

                updatePublication(body, this.claimTo._id)
                    .then((response)=>{
                        let claimTo = cloneDeep(this.claimTo)

                        claimTo.managing_editor = this.des.managing_editor

                        this.$store.dispatch('updateRegisteredPublication', claimTo)
                        this.updateSource('MANANGING_RIGHTS', claimTo)

                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, (response.message))
                    })
                    .catch((error)=>{
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })

            })
        },
        submitLocationForm(module, formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                loader(this, true)
                
                let body = {
                    address: {}
                }

                if(this.address.line1 !== ''){
                    body.address.line1 = this.address.line1
                }

                if(this.address.line2 !== ''){
                    body.address.line2 = this.address.line2
                }

                if(this.address.postal_code !== ''){
                    body.address.postal_code = this.address.postal_code
                }

                if(this.address.city !== ''){
                    body.address.city = this.address.city
                }

                if (!isEmpty(this.selectedState)) {
                    body.address.state = this.selectedState._id
                }

                if(this.address.country_code !== ''){
                    body.address.country_code = this.address.country_code
                }
                if (this.address.country_name !== '') body.address.country_name = this.address.country_name

                if(module === constants.AUTHOR.key){
                    updateAuthor(body, this.claimTo._id)
                        .then((response)=>{
                            let claimTo = this.claimTo

                            claimTo.address = body.address
                            this.updateSource('ADDRESS', claimTo)
                            this.$store.dispatch('updateRegisteredAuthor', claimTo)

                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, (response.message))
                        })
                        .catch((error)=>{
                            loader(this, false)
                            message(this, constants.messageType.ERROR, (error.message))
                        })
                }else if(module === constants.PUBLISHER.key){
                    body.contact_detail = this.contact_detail

                    updatePublisher(body, this.claimTo._id)
                        .then((response)=>{
                            let claimTo = this.claimTo

                            claimTo.address = body.address
                            claimTo.contact_detail = body.contact_detail

                            this.$store.dispatch('updateRegisteredPublisher', claimTo)
                            this.updateSource('ADDRESS', claimTo)
                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, (response.message))
                        })
                        .catch((error)=>{
                            loader(this, false)
                            message(this, constants.messageType.ERROR, (error.message))
                        })
                } else if(module === constants.PUBLICATION.key){

                    updatePublication(body, this.claimTo._id)
                        .then((response)=>{
                            let claimTo = this.claimTo

                            claimTo.address = body.address
                            this.updateSource('ADDRESS', claimTo)
                            this.$store.dispatch('updateRegisteredPublication', claimTo)

                            loader(this, false)
                            message(this, constants.messageType.SUCCESS, (response.message))
                        })
                        .catch((error)=>{
                            loader(this, false)
                            message(this, constants.messageType.ERROR, (error.message))
                        })

                }

            })
        },
        getDescriptionSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Give a short description and biography of the Author in the fields below'
                case constants.PUBLISHER.key:
                    return 'Give a short description and biography of the Publisher in the fields below'
                case constants.PUBLICATION.key:
                    return 'Give a short description and biography of the Publication in the fields below'
            }
        },
        getLocationHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Location'
                case constants.PUBLISHER.key:
                    return 'Publisher Location'
                case constants.PUBLICATION.key:
                    return 'Publication Location'
                case 'USER':
                    return 'User Location'    
            }
        },
        getLocationSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Please provide the main location of the Author'
                case constants.PUBLISHER.key:
                    return 'Please provide the main location of the Publisher'
                case constants.PUBLICATION.key:
                    return 'Please provide the main location of the Publication'
                case 'USER':
                    return 'User Address'    
            }
        },
        submit(module){
            switch (module){
                case constants.AUTHOR.key:
                    this.submitAuthorForm(['manageAuthorDescription', 'manageAuthorLocation'])
                    break
                case constants.PUBLISHER.key:
                    this.submitPublisherForm(['manageAuthorDescription', 'manageAuthorLocation'])
                    break
                case constants.PUBLICATION.key:
                    this.submitPublicationForm(['manageAuthorDescription', 'manageAuthorLocation', 'managePublicationEditor'])
                    break
            }
        },
        handleInputConfirm (item) {
            this.address.country_code = item.country_code || ''
            this.address.country_name = item.country_name || ''
            this.states = [];
            this.searchState = ''
            this.selectedState = {}
            this.fetchStateList(item)
        },
        querySearch: async function (search, cb) {
            if (search === '' && search === null && search.length < 1) return 
            let results = []
            if (!isEmpty(this.countries)) {
                 results = await filter(this.countries, (c) => {
                   return c.country_name.toLowerCase().includes(search.toLowerCase())
                })
            }
            cb(results)
        },
        getCountryName () {
            let result = ''
            if (this.address && this.address.country_code) {
                filter(this.countries, (country) => {
                    if (country.country_code === this.address.country_code) {
                        result = country.country_name;
                        // fetch state list initially
                        this.fetchStateList(country)
                    }
                })
            }
            return result
        },
        backbutton () {
            this.submitPublisherForm(['manageAuthorDescription', 'manageAuthorLocation'], true)
        },
        updateDescriptionForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                let claimTo = this.claimTo
                claimTo.biography = this.des.biography
                claimTo.short_description = this.des.short_description
            })
        },
        updateLocationForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return
                let claimTo = this.claimTo
                claimTo.address = this.address
                claimTo.contact_detail = this.contact_detail
            })
        },
        /**
         * called to save the form
         */
        saveForm (module, type) {
            switch (type){
                case 'DESCRIPTION':
                    this.submitDescriptionNewForm(['manageAuthorDescription'])
                break
                case 'LOCATION':
                    this.submitLocationNewForm(['manageAuthorLocation'])
                break
            }
        },
        /**
         * save desc form
         */
        submitDescriptionNewForm (forms) {
            let claimTo = this.claimTo
            let isAllFormsValid = true
            forms.map((formName)=>{
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        isAllFormsValid = false
                    }
                })
            })
            if(isAllFormsValid) {
                claimTo.biography = this.des.biography
                claimTo.short_description = this.des.short_description
            }
        },
        /**
         * save desc form
         */
        submitLocationNewForm (forms) {
            let isAllFormsValid = true
            let claimTo = this.claimTo
            forms.map((formName)=>{
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        isAllFormsValid = false
                    }
                })
            })
            if(isAllFormsValid) {
                claimTo.address = this.address
            }
        },

        async findState () {
            if (this.addressToBeEdited && this.addressToBeEdited.country_code) {
                const findCountry = find(this.countries, {country_code: this.addressToBeEdited.country_code});
                if (findCountry) {
                    await this.fetchStateList(findCountry);
                    if (this.isEdit && this.addressToBeEdited.state) {
                        const findState = find(this.states, {_id: this.addressToBeEdited.state});
                        if (findState) {
                            this.selectedState = findState
                            this.searchState = findState.state_code
                        }
                    }
                }
            }
        },
        /**
         * validate postal code
         * @param {*} rule 
         * @param {*} value 
         * @param {*} callback 
         */
         validatePostalCodeFunction (rule, value, callback) {
            let regex = ''
            if (this.address.country_code && this.address.country_code !== '') {
                // find the address code and regex
                const code = find(countryCode, {abbrev: this.address.country_code})
                regex = (code && code.postal) || ''
           }
           // validate postal code on basis of regex
           if (regex !== '' && value && value !== '' && !new RegExp(regex).test(value)) callback(new Error('Invalid Postal code'))
           else callback()
       },
    }
}